import { ApiProperty } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { RepairTypeEnum } from '../../repair/enums/repair-type.enum';
import { JobPhaseBumpCommonDto } from '../../job-phase-bump/dtos/job-phase-bump-common.dto';
import { ScheduledEmailsBumpResourceReminderInterface } from '../interfaces/scheduled-emails-bump-resource-reminder.interface';
import { PhaseTypeEnum } from '../../phase/enums/phase-type.enum';
import { BumpResourceSheetType } from '../../bump-resource-sheet/enums/bump-resource-sheet.enum';

@Exclude()
export class ScheduledEmailsBumpResourceReminderDto
  extends JobPhaseBumpCommonDto
  implements ScheduledEmailsBumpResourceReminderInterface
{
  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated Subdivision ID',
  })
  @Expose()
  subdivisionId!: string;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated Builder ID',
  })
  @Expose()
  builderId!: string;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated Supervisor User ID',
  })
  @Expose()
  supervisorUserId!: string;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated Region ID',
  })
  @Expose()
  regionId!: string;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated Contractor ID',
  })
  @Expose()
  contractorId!: string;

  @ApiProperty({
    title: 'Contractor name',
    type: 'string',
  })
  @Expose()
  contractorName!: string;

  @ApiProperty({
    title: 'Subdivision name',
    type: 'string',
  })
  @Expose()
  subdivisionName!: string;

  @ApiProperty({
    title: 'Builder name',
    type: 'string',
  })
  @Expose()
  builderName!: string;

  @ApiProperty({
    title: 'Lot',
    description: 'The lot number/identifier',
  })
  @Expose()
  jobLot!: string;

  @ApiProperty({
    title: 'Total worked hours',
    type: 'number',
  })
  @Expose()
  workedHours!: number;

  @ApiProperty({
    title: 'Is Logged hours adjusted?',
    type: 'boolean',
  })
  @Expose()
  isLoggedHoursAdjusted!: boolean;

  @ApiProperty({
    title: 'Date',
    type: 'string',
    format: 'date-time',
  })
  @Expose()
  repairDate!: Date;

  @ApiProperty({
    type: 'string',
    title: 'Repair Type',
  })
  @Expose()
  repairType!: RepairTypeEnum | PhaseTypeEnum;

  @ApiProperty({
    type: 'enum',
    enum: BumpResourceSheetType,
  })
  @Expose()
  bumpResourceType!: BumpResourceSheetType;

  @ApiProperty({
    title: 'Contractor user email',
    type: 'string',
  })
  @Expose()
  contractorUserEmail!: string;

  @ApiProperty({
    title: 'Contractor first name',
    type: 'string',
  })
  @Expose()
  contractorUserFirstName!: string;

  @ApiProperty({
    title: 'Contractor last name',
    type: 'string',
  })
  @Expose()
  contractorUserLastName!: string;
}
